// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2yt0u","buttons":"PendingPaymentAlert_buttons__4hfpj"};